<label for="{{ label() }}" class="h-6 uppercase text-xs font-bold text-gray-700 tracking-wider">{{ label() }}</label>
<div class="w-full h-full align-baseline pl-3"><ng-content></ng-content></div>